import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../../core/data-access/http-client/clients/api-client-provider.service';
import { AssignRevokePermissionsInMemoryClient } from './assign-revoke-permissions-in-memory.client';
import { AssignRevokePermissionsClient } from './assign-revoke-permissions.client';
import { IAssignRevokePermissionsClient } from './i-assign-revoke-permissions.client';

@Injectable({
    providedIn: 'root'
})
export class AssignRevokePermissionsClientProvider extends ApiClientProvider<IAssignRevokePermissionsClient> {
    constructor(private client: AssignRevokePermissionsClient, private inMemoryClient: AssignRevokePermissionsInMemoryClient) {
        super();
    }

    protected override getInMemoryClient(): IAssignRevokePermissionsClient {
        return this.inMemoryClient;
    }
    protected override getApiClient(): IAssignRevokePermissionsClient {
        return this.client;
    }
}
